import { render, staticRenderFns } from "./QuotesCompare.vue?vue&type=template&id=1bfe3ea4&scoped=true&"
import script from "./QuotesCompare.vue?vue&type=script&lang=js&"
export * from "./QuotesCompare.vue?vue&type=script&lang=js&"
import style0 from "./QuotesCompare.vue?vue&type=style&index=0&id=1bfe3ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe3ea4",
  null
  
)

export default component.exports